// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M5GZ","top":"styles_top__1U9f2"};